import { render, staticRenderFns } from "./PresentationImage.vue?vue&type=template&id=d317d2f6&scoped=true&"
import script from "./PresentationImage.vue?vue&type=script&lang=js&"
export * from "./PresentationImage.vue?vue&type=script&lang=js&"
import style0 from "./PresentationImage.vue?vue&type=style&index=0&id=d317d2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d317d2f6",
  null
  
)

export default component.exports